import { useRef, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { RootState } from '../../../redux/store';
import { isAppOpenedInIframe } from '../../../screens/loginScreen/LoginScreen';
import { sendMessageToInsperaIB } from '../../../api/authApis';

const MAX_RETRY = 4;
export const useInsperaIB = ({ setUploadingTest } : { setUploadingTest: React.Dispatch<React.SetStateAction<boolean>> }) => {
    const { testTaker, insperaDetails } = useSelector((state: RootState) => state.appConfigSlice);

    const [isFailedInsperaTestClosure, setIsFailedInsperaTestClosure] = useState(false);
    const [acknowledged, setAcknowledged] = useState(false);
    const retryInterval = useRef<ReturnType<typeof setTimeout>>();
    const retryTimes = useRef(0);


    useEffect(() => {
        if (!isAppOpenedInIframe()) return;

        const handleMessageReceive = (event: any) => {
            const data = event.data;
            if (data.type === 'ACK_TEST_COMPLETED') {
                retryTimes.current = 0;
                setAcknowledged(true);
                setUploadingTest(false);
                setIsFailedInsperaTestClosure(false);
                clearInterval(retryInterval.current);
            }
        };

        window.addEventListener('message', handleMessageReceive);

        return () => {
            window.removeEventListener('message', handleMessageReceive);
            clearInterval(retryInterval.current);
        };
    }, []);

    const sendMessageToIIB = () => {
        if (!isAppOpenedInIframe()) return;

        /**
         * Send Test Completed message to Inspera IB
         */
        retryInterval.current = setInterval(() => {
            sendMessageToInsperaIB({
                type: 'TEST_COMPLETED',
                ARID: insperaDetails.assessmentId,
                TestTakerID: testTaker.testTakerId,
            });

            retryTimes.current++;
            if (retryTimes.current >= MAX_RETRY) {
                setIsFailedInsperaTestClosure(true);
                clearInterval(retryInterval.current);
            }
        }, 3000);
    };

    return { awaitingAcknowledgement: acknowledged, isFailedInsperaTestClosure, sendMessageToIIB, insperaDetails };
};
